/* Published evidence only. No headline rewriting or synthetic research records. */
export function editorialContent(edition) {
  return edition?.newsletter || edition?.content || {};
}
export function editionSummary(edition) {
  const content = editorialContent(edition);
  return (content.in_60_seconds || edition?.summary || []).filter(item => typeof item === 'string').slice(0, 3);
}
export function isOlderEdition(edition, now = Date.now()) {
  const timestamp = Date.parse(edition?.publishedAt || edition?.date || '');
  return Number.isFinite(timestamp) && now - timestamp > 36 * 3600000;
}
export function publishedNotes(edition) {
  const sections = editorialContent(edition).sections || {};
  return [
    ['rotation_watch', 'Positioning', 'Where exposure is changing'],
    ['leverage_check', 'Derivatives', 'The cost of holding the trade'],
    ['follow_the_money', 'Capital flows', 'Follow the evidence'],
  ].filter(([key]) => sections[key]?.body).map(([key, label, title]) => ({
    key, label, title, body: sections[key].body.split(/\n\s*\n/)[0],
  }));
}
export function evidenceRows(edition) {
  const rows = editorialContent(edition).data_room?.derivatives || edition?.derivatives || [];
  return rows.filter(row => row.reading && row.metric).slice(0, 4);
}
export function publicationTitle(edition) {
  return editorialContent(edition).headline || edition?.headline || 'AEON Research';
}
